'use client'
import {Button, Select} from '@local/ui/components'
import React, {ChangeEvent, useState} from 'react'
import EyeSVG from '@local/assets/svgs/icon-eye.svg'
import GlobeSVG from '@local/assets/svgs/icon-globe.svg'
import {useRouter, useSearchParams} from 'next/navigation'

const createTripTypeOptions = () => {
	return [
		{label: 'Group Retreats', value: 'group-retreat'},
		{label: 'Private Journeys', value: 'private-journey'},
		{label: 'Kaer For Business', value: 'kaer-for-business'},
	]
}

interface RetreatFilterProps {
	maxPeopleCount?: number
	locations?: {label: string, value: string}[]
}
export const RetreatFilter = ({locations}: RetreatFilterProps) => {
	const router = useRouter()

	const searchParams = useSearchParams()
	const [destination, setDestination] = useState<string>(searchParams.get('destination') || '')
	const [guestCounts, setGuestCounts] = useState<string>(searchParams.get('guestCounts') || '')
	const [tripType, setTripType] = useState<string>(searchParams.get('tripType') || '')

	const handleDestination = (e: ChangeEvent<HTMLSelectElement>) => {
		setDestination(e.target.value)
	}

	const handleTripType = (e: ChangeEvent<HTMLSelectElement>) => {
		setTripType(e.target.value)
	}

	const handleSearch = () => {
		// TODO: Implement search with search params to redirect /experiences?destination=London&guestCounts=2&tripType=Retreat&date=2024-01-01
		const searchParams = new URLSearchParams()
		searchParams.set('destination', destination)
		searchParams.set('guestCounts', guestCounts)
		searchParams.set('tripType', tripType)
		router.push(`/experiences?${searchParams.toString()}`)
	}

	return (
		<div id='retreat-filter' className='flex flex-col  gap-y-10 w-full max-w-[294px] mx-auto items-center lg:h-48 lg:flex-row lg:max-w-none lg:w-auto '>
			<Select
				key={`destination-select-${destination}`}
				theme='light'
				name='destination'
				id='product-hero-destination-select'
				placeholder='Destination'
				onChange={handleDestination}
				options={locations || []}
				value={destination}
				containerClassName='border-0 w-full lg:w-200'
				className='border-0 border-r !rounded-none uppercase h-48'
				keepPrefixIcon
				prefixIcon={<GlobeSVG className='w-16 h-16 mr-4 shrink-0' />} />
			<Select
				key={`trip-type-select-${tripType}`}
				theme='light'
				name='trip-type'
				id='product-hero-trip-type-select'
				placeholder='Trip Type'
				onChange={handleTripType}
				options={createTripTypeOptions()}
				value={tripType}
				containerClassName='border-0 w-full lg:w-200 '
				className='border-0 border-r !rounded-none h-48'
				keepPrefixIcon
				prefixIcon={<EyeSVG className='w-16 h-16 mr-4 shrink-0' />} />

			<Button variant='primary' className='border-0 rounded-none small w-full h-48 lg:w-auto' onClick={handleSearch} label='Search' />

		</div>
	)
}
